import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const RaceSliderHrList = withConfig(theme => styled('div', { label: 'RaceSliderHrList' })`
    border-radius: 8px;
    border: ${theme.star.racingNextOff.raceBox.borderColorSecondary === '' ? 'none' : `2px solid ${theme.star.racingNextOff.raceBox.borderColorSecondary}`};
    flex: 0 0 300px;
    overflow: hidden;
    position: relative;
    width: 300px;
`);
